import { render, staticRenderFns } from "./ConfigMain.vue?vue&type=template&id=b217f890&scoped=true"
import script from "./ConfigMain.vue?vue&type=script&lang=js"
export * from "./ConfigMain.vue?vue&type=script&lang=js"
import style0 from "./ConfigMain.vue?vue&type=style&index=0&id=b217f890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b217f890",
  null
  
)

export default component.exports